import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import Table from "./LandlordCompanyTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import Popup from "reactjs-popup";
import { PopupMessage } from "../../utils/utils";
import styles from "../master.css";
import { clientAccess } from "../../utils/index";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};
class LandlordCompanyDetails extends React.Component {
  state = {
    id: undefined,
    clientGroups: [],
    clientList: [],
    landlordGroups: [],
    popupContent: "",
    messsagePopup: false,
    delete: false,
    companyName: [],
    companyCode: "",
    companyCode: "",
    companyPan: "",
    companyTan: "",
    vendorCode: "",
    companyType: "",
    redirect: false,
    isOpen: false,
    groupId: "",
    url: `${apiUrl.apiUrl.url}/broker/create`,
    initialValues: {
      cgroupId: "",
      cgroupName: "",
      clientId: "",
      clientName: "",
      companyName: "",
      companyCode: "",
      companyType: "",
      companyPan: "",
      companyTan: "",
      vendorCode: "",
      groupId: "",
      groupName: "",
    },
  };

  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/client-group/fetch-list`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          clientGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
    //fetch(`${apiUrl.apiUrl.url}/landlord-groups`)
    fetch(`${apiUrl.apiUrl.url}/broker-group/fetch-broker-list`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          landlordGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  changeGroup = (e) => {
    let groupid = e.target.value;
    fetch(`${apiUrl.apiUrl.url}/broker/get-group-companies/?id=` + groupid, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          companyName: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  constructor(props) {
    super(props);
  }

  checkDelete() {
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/broker/check-delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        self.setState({
          messsagePopup: true,
          popupContent: "Sorry you cannot delete this item"
        });

      } else {
        self.setState({
          delete: true
        });
      }

    });
  }

  componentDidUpdate() {
    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;
      if (this.props.match.params.id === undefined) {
        this.setState({
          url: `${apiUrl.apiUrl.url}/broker/create`,
          initialValues: {
            cgroupId: "",
            cgroupName: "",
            clientId: "",
            clientName: "",
            companyName: "",
            companyCode: "",
            companyType: "",
            companyPan: "",
            companyTan: "",
            groupId: "",
            groupName: "",
          },
        });
      } else {
        let athis = this;
        axios.get(`${apiUrl.apiUrl.url}/broker/get-company/?id=${this.props.match.params.id}`).then((response) => {
          let data = response.data;
          athis.setState({
            url: `${apiUrl.apiUrl.url}/broker/update?id=${athis.props.match.params.id}`,
            initialValues: data.data,
            clientGroups: data.clientGroups,
            clientList: data.clientList,
          });
        }).catch((error) => {});

        // fetch(
        //   `${apiUrl.apiUrl.url}/broker/get-company/?id=${this.props.match.params.id}`
        // )
        //   .then((response) => {
        //     return response.json();
        //   })
        //   .then((data) => {
        //     this.setState({
        //       url: `${apiUrl.apiUrl.url}/broker/update?id=${this.props.match.params.id}`,
        //       initialValues: data.data,
        //       clientGroups: data.clientGroups,
        //       clientList: data.clientList,
        //     });
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
      }
    }
  }

  handleChangeLandlordGroup = (newValue, actionMeta) => {
    console.group("Value Changed");
    // this.state.groupId = newValue.value;
    this.state.initialValues.groupId = newValue.value;
    this.state.initialValues.groupName = newValue.label;
    this.setState({});
    // this.groupId = newValue.value;
    console.groupEnd();
  };
  handleChangeclientGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionMeta", actionMeta);

    if (actionMeta == "change_client_group") {
      this.state.initialValues.cgroupId = newValue.value;
      this.state.initialValues.cgroupName = newValue.label;

      fetch(`${apiUrl.apiUrl.url}/client/client-list?groupId=` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            clientList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      console.log("inside", actionMeta);
    } else {
      this.state.initialValues.clientId = newValue.value;
      this.state.initialValues.clientName = newValue.label;
    }
    this.setState({});
    //this.state.initialValues.groupName = newValue.label;

    this.cgroupId = newValue;
    console.log(this.cgroupId, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };

  redirectToDelete = () => {
    this.setState({ delete: false });
    var ths = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/broker/delete?id=${this.state.id}`,
    }).then(function (response) {

      if (!response.data.success) {
        ths.setState({
          messsagePopup: true,
          popupContent: "Something Went Wrong",

        });
      } else {
        ths.setState({
          messsagePopup: true,
          popupContent: "Data Deleted Successfully",
        });
      }
    });
  };

  redirectAfterSave = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        cgroupId: "",
        cgroupName: "",
        clientId: "",
        clientName: "",
        companyName: "",
        companyCode: "",
        companyType: "",
        companyPan: "",
        companyTan: "",
        groupId: "",
        groupName: "",
      },
    });
  };

  redirectAfterEdit = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        cgroupId: "",
        cgroupName: "",
        clientId: "",
        clientName: "",
        companyName: "",
        companyCode: "",
        companyType: "",
        companyPan: "",
        companyTan: "",
        groupId: "",
        groupName: "",
      },
    });
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/broker-company-details" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>
                <Link to="/masters">Masters</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="/masters/broker-directory">Broker Directory</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="#">Broker Company Details</Link>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          onSubmit={(values, actions) => {
            values.groupId = this.state.initialValues.groupId;
            var self = this;
            axios({
              method: "post",
              url: this.state.url,
              data: values,
            }).then(function (response) {
              if (!response.data.success) {
                actions.setSubmitting(false);
                actions.setErrors(response.data);
              } else {
                self.setState({
                  messsagePopup: true,
                  popupContent: "Data Saved Successfully!"
                });
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <>
              <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">
                      {clientAccess() && (
                        <div className="newGridSectionInner">
                          <label>
                            Client Group <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                              name="clientGroup"
                              onChange={(e) => {
                                this.handleChangeclientGroup(e, "change_client_group");
                              }}
                              value={{
                                label: this.state.initialValues.cgroupName,
                                value: this.state.initialValues.cgroupId,
                              }}
                              options={this.state.clientGroups.map((item) => ({
                                label: item.group_name,
                                value: item.id,
                              }))}
                            />
                            <ErrorMessage name="clientGroup" component="div" className="text-red" />
                          </div>
                        </div>
                      )}
                      {clientAccess() && (
                        <div className="newGridSectionInner">
                          <label>
                            Client Name <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                              name="clientName"
                              onChange={(e) => {
                                this.handleChangeclientGroup(e, "change_client_name");
                              }}
                              value={{
                                label: this.state.initialValues.clientName,
                                value: this.state.initialValues.clientId,
                              }}
                              options={this.state.clientList.map((item) => ({
                                label: item.client_name,
                                value: item.id,
                              }))}
                            />
                            <ErrorMessage name="clientName" component="div" className="text-red" />
                          </div>
                        </div>
                      )}
                      <div className="newGridSectionInner">
                        <label>
                          Company Group <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <CreatableSelect
                            name="groupId"
                            onChange={(e) => {
                              this.handleChangeLandlordGroup(e);
                            }}
                            value={{
                              label: this.state.initialValues.groupName,
                              value: this.state.initialValues.groupId,
                            }}
                            options={this.state.landlordGroups.map((item) => ({
                              label: item.name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="groupId" component="div" className="text-red" />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          Company Name <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            type="text"
                            name="companyName"
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          />
                          <ErrorMessage name="companyName" component="div" className="text-red" />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>Company ID</label>
                        <div className="position-relative">
                          <Field
                            type="text"
                            name="companyCode"
                            readonly="readonly"
                            onChange={(e) => {
                              this.setState({ companyCode: e.target.value });
                              handleChange(e);
                            }}
                          />
                          <ErrorMessage name="companyCode" component="div" className="text-red" />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          Company Type <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="companyType"
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            <option value="Limited Company" label="Limited Company" />
                            <option value="Private Limited Company" label="Private Limited Company" />
                            <option value="Limited Liability Partnership" label="Limited Liability Partnership" />
                            <option value="Partnership" label="Partnership" />
                            <option value="Sole Proprietor" label="Sole Proprietor" />
                            <option value="Proprietorship" label="Proprietorship" />
                            <option value="Hindu Undivided Family" label="Hindu Undivided Family" />
                            <option value="Individual" label="Individual" />
                            <option value="One Person Company (OPC)" label="One Person Company (OPC)" />
                            <option value="Non Government Organization" label="Non Government Organization" />
                          </Field>
                          <ErrorMessage name="companyType" component="div" className="text-red" />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>PAN Number</label>
                        <div className="position-relative">
                          <Field
                            type="text"
                            name="companyPan"
                            onChange={(e) => {
                              this.setState({ companyPan: e.target.value });
                              handleChange(e);
                            }}
                          />
                          <ErrorMessage name="companyPan" component="div" className="text-red" />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>TAN Number</label>
                        <div className="position-relative">
                          <Field
                            type="text"
                            name="companyTan"
                            onChange={(e) => {
                              this.setState({ companyTan: e.target.value });
                              handleChange(e);
                            }}
                          />
                          <ErrorMessage name="companyTan" component="div" className="text-red" />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>Vendor Code</label>
                        <div className="position-relative">
                          <Field
                            type="text"
                            name="vendorCode"
                            onChange={(e) => {
                              this.setState({ vendorCode: e.target.value });
                              handleChange(e);
                            }}
                          />
                          <ErrorMessage name="vendorCode" component="div" className="text-red" />
                        </div>
                      </div>
                    </div>
                    {this.props.match.params.id !== undefined ? (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="update_button" disabled={isSubmitting}>
                          Update
                        </button>
                        <button
                          className="delete_button"
                          type="button"
                          onClick={(e) => {
                            this.checkDelete(e);
                          }}>
                          Delete
                        </button>
                        <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                          <Link to="/masters/broker-company-details">
                            Reset
                          </Link>
                        </button>
                      </div>
                    ) : (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="add_button" disabled={isSubmitting}>
                          Add
                        </button>
                        <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                          Reset
                        </button>
                      </div>
                    )}
                  </div>
                </Form>
              </div>

              {/* <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="container">
                    <div className="row">
                      {clientAccess() &&
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Client Group <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-7">

                                <Select
                                  className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                  name="clientGroup"
                                  //onInputChange={this.handleChange}
                                  onChange={(e) => {
                                    this.handleChangeclientGroup(
                                      e,
                                      "change_client_group"
                                    );
                                  }}
                                  value={{
                                    label: this.state.initialValues.cgroupName,
                                    value: this.state.initialValues.cgroupId,
                                  }}
                                  options={this.state.clientGroups.map(
                                    (item) => ({
                                      label: item.group_name,
                                      value: item.id,
                                    })
                                  )}
                                />

                                <ErrorMessage
                                  name="clientGroup"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      }{clientAccess() &&
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Client Name <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-7">
                                <Select
                                  className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                  name="clientName"
                                  onChange={(e) => {
                                    this.handleChangeclientGroup(
                                      e,
                                      "change_client_name"
                                    );
                                  }}
                                  value={{
                                    label: this.state.initialValues.clientName,
                                    value: this.state.initialValues.clientId,
                                  }}
                                  options={this.state.clientList.map((item) => ({
                                    label: item.client_name,
                                    value: item.id,
                                  }))}
                                />
                                <ErrorMessage
                                  name="clientName"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Company Group <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <CreatableSelect
                                name="groupId"
                                onChange={(e) => {
                                  this.handleChangeLandlordGroup(e);
                                }}
                                value={{
                                  label: this.state.initialValues.groupName,
                                  value: this.state.initialValues.groupId,
                                }}
                                options={this.state.landlordGroups.map(
                                  (item) => ({
                                    label: item.name,
                                    value: item.id,
                                  })
                                )}
                              />
                              <ErrorMessage
                                name="groupId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Company Name <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                type="text"
                                name="companyName"
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                              />
                              <ErrorMessage
                                name="companyName"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Company ID
                            </label>
                            <div className="col-sm-7">
                              <Field
                                type="text"
                                name="companyCode"
                                readonly="readonly"
                                // value={this.state.companyCode}
                                onChange={(e) => {
                                  this.setState({ companyCode: e.target.value });
                                  handleChange(e);
                                }}
                              />
                              <ErrorMessage
                                name="companyCode"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Company Type <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="companyType"
                                // value={this.state.companyType}
                                onChange={(e) => {
                                  // this.setState({ companyType: e.target.value });
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                <option
                                  value="Limited Company"
                                  label="Limited Company"
                                />
                                <option
                                  value="Private Limited Company"
                                  label="Private Limited Company"
                                />
                                <option
                                  value="Limited Liability Partnership"
                                  label="Limited Liability Partnership"
                                />
                                <option value="Partnership" label="Partnership" />
                                <option
                                  value="Sole Proprietor"
                                  label="Sole Proprietor"
                                />
                                <option
                                  value="Proprietorship"
                                  label="Proprietorship"
                                />
                                <option
                                  value="Hindu Undivided Family"
                                  label="Hindu Undivided Family"
                                />
                                <option value="Individual" label="Individual" />
                                <option
                                  value="One Person Company (OPC)"
                                  label="One Person Company (OPC)"
                                />
                                <option
                                  value="Non Government Organization"
                                  label="Non Government Organization"
                                />
                              </Field>
                              <ErrorMessage
                                name="companyType"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              PAN Number
                            </label>
                            <div className="col-sm-7">
                              <Field
                                type="text"
                                name="companyPan"
                                // value={this.state.in.companyPan}
                                onChange={(e) => {
                                  this.setState({ companyPan: e.target.value });
                                  handleChange(e);
                                }}
                              />
                              <ErrorMessage
                                name="companyPan"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              TAN Number
                            </label>
                            <div className="col-sm-7">
                              <Field
                                type="text"
                                name="companyTan"
                                // value={this.state.companyTan}
                                onChange={(e) => {
                                  this.setState({ companyTan: e.target.value });
                                  handleChange(e);
                                }}
                              />
                              <ErrorMessage
                                name="companyTan"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Vendor Code
                            </label>
                            <div className="col-sm-7">
                              <Field
                                type="text"
                                name="vendorCode"
                                // value={this.state.companyTan}
                                onChange={(e) => {
                                  this.setState({ vendorCode: e.target.value });
                                  handleChange(e);
                                }}
                              />
                              <ErrorMessage
                                name="vendorCode"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {this.props.match.params.id !== undefined ? (
                      <div className="row">
                        <div className="col-lg-6 offset-lg-6">
                          <div className="btnContainer">
                            <div>
                              <button type="submit" disabled={isSubmitting}>
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={(e) => {
                                  this.checkDelete(e);
                                }}
                              >
                                Delete
                              </button>
                              <button type="reset" onClick={this.redirectAfterEdit}>
                                <Link to="/masters/broker-company-details">
                                  Reset
                                </Link>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="row">
                        <div className="col-lg-6 offset-lg-6">
                          <div className="btnContainer">
                            <div>
                              <button type="submit" disabled={isSubmitting}>
                                Add
                              </button>
                              <button type="reset" onClick={this.redirectAfterEdit}>
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </Form>
              </div> */}
            </>
          )}
        </Formik>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              "Delete the item?"
              <a className="close" onClick={this.redirectAfterSave}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <Table />
      </>
    );
  }
}

export default withRouter(LandlordCompanyDetails);
